import { render, staticRenderFns } from "./TemperatureSelect.vue?vue&type=template&id=ed06315c&scoped=true"
import script from "./TemperatureSelect.vue?vue&type=script&lang=js"
export * from "./TemperatureSelect.vue?vue&type=script&lang=js"
import style0 from "./TemperatureSelect.vue?vue&type=style&index=0&id=ed06315c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed06315c",
  null
  
)

export default component.exports